// Aplica CSS custom properties desde el global settings de la sucursal.
// Se llama una vez al cargar /state.

type ThemeColors = {
  color_primary: string;
  color_accent: string;
};

export function applyTheme(colors: ThemeColors): void {
  const root = document.documentElement;
  root.style.setProperty("--color-primary", colors.color_primary);
  root.style.setProperty("--color-accent", colors.color_accent);
}
